import { message } from "antd";
import ProcessDesignApi from "api/ProcessDesignApi";
import { call, put, select } from "redux-saga/effects";
import { APP_MODE } from "entities/App";
import { getWidgetsMeta, currentPageId } from "sagas/selectors";
import { getAppMode } from "ee/selectors/applicationSelectors";
import type {
  TInitiateApprovalProcessDescription,
  TSubmitApprovalProcessFormDescription,
} from "workers/Evaluation/fns/approvalProcess";

export function* initiateApprovalProcessSaga(
  action: TInitiateApprovalProcessDescription,
): Generator<any, any, any> {
  try {
    const { processId } = action.payload;
    const widgetsMeta = yield select(getWidgetsMeta);
    const mode: APP_MODE = yield select(getAppMode);

    if (mode === APP_MODE.EDIT) {
      message.warning("请发布应用后使用发起流程功能");
      return;
    }

    if (!processId || processId === "none") {
      message.warning("请选择关联流程");
      return;
    }

    // 调用审批流程 API
    const response = yield call(ProcessDesignApi.startProcessApplication, {
      processId,
      formData: widgetsMeta,
    });

    const { responseMeta = {} } = response;
    const { success, error } = responseMeta;

    if (success) {
      // 处理成功响应
      yield put({
        type: "INITIATE_APPROVAL_PROCESS_SUCCESS",
        payload: response,
      });
      return response;
    } else {
      yield put({
        type: "INITIATE_APPROVAL_PROCESS_ERROR",
        payload: { error },
      });
      throw error instanceof Error ? error : new Error("发起流程失败");
    }
  } catch (error) {
    // 处理错误
    yield put({
      type: "INITIATE_APPROVAL_PROCESS_ERROR",
      payload: { error },
    });
    throw error instanceof Error ? error : new Error("发起流程失败");
  }
}

export function* submitApprovalProcessFormSaga(
  action: TSubmitApprovalProcessFormDescription,
): Generator<any, any, any> {
  try {
    const widgetsMeta = yield select(getWidgetsMeta);
    const pageId = yield select(currentPageId);
    const mode: APP_MODE = yield select(getAppMode);
    const searchParams = new URLSearchParams(window.location.search);
    const taskId = searchParams.get("taskId");
    if (!taskId) {
      message.warning("无关联任务信息！");
      return;
    }
    if (mode === APP_MODE.EDIT) {
      message.warning("请发布应用后提交表单");
      return;
    }
    const request = {
      pageId,
      formData: widgetsMeta,
    };
    const response = yield call(
      ProcessDesignApi.submitFormTask,
      taskId,
      request,
    );
    const { responseMeta = {} } = response;
    const { success, error } = responseMeta;
    if (success) {
      yield put({
        type: "SUBMIT_APPROVAL_PROCESS_FORM_SUCCESS",
        payload: response,
      });
    } else {
      yield put({
        type: "SUBMIT_APPROVAL_PROCESS_FORM_ERROR",
        payload: { error },
      });
      throw error instanceof Error ? error : new Error("表单提交失败");
    }
  } catch (error) {
    // 处理错误
    yield put({
      type: "SUBMIT_APPROVAL_PROCESS_FORM_ERROR",
      payload: { error },
    });
    throw error instanceof Error ? error : new Error("表单提交失败");
  }
}
